/** Default inline styles for admin user text inputs (add page). Edit page overrides via getFieldStyle. */
export const ADMIN_USER_BASE_FIELD_STYLE = {
  backgroundColor: 'var(--color-surface)',
  border: '2px solid var(--color-border)',
  color: 'var(--color-text)'
};

/**
 * @param {((value: unknown, isRequired?: boolean, fieldName?: string) => object) | undefined} getFieldStyle
 * @param {unknown} value
 * @param {boolean} [isRequired]
 * @param {string} [fieldName]
 */
export function resolveAdminUserFieldStyle(getFieldStyle, value, isRequired = false, fieldName) {
  if (typeof getFieldStyle === 'function') {
    return getFieldStyle(value, isRequired, fieldName);
  }
  return ADMIN_USER_BASE_FIELD_STYLE;
}
